import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../../core/service/v2/abstractRepositoryV2';
import {Scanner3dModel} from '../../../api/entity/scanner3d.model';

@Injectable()
export class Scanner3dRepository extends AbstractRepositoryV2<Scanner3dModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('Scanner3d', serviceElementsFactory, injector);
    }
}
